<template>
    <el-dialog class="org-select dialog-large" :visible.sync="dialogVisible" @close="closeDialog" :close-on-click-modal="false" :title="$STR('WAREHOUSE.orgSelectVisible.title', '选择组织')">
        <el-tabs v-model="searchParam.orgType" @tab-click="queryList()">
            <el-tab-pane :label="type.name" :name="type.id" v-for="type in statusMap" :key="type.id"></el-tab-pane>
        </el-tabs>
        <div>
            <el-input :placeholder="$STR('goods.goodsPublish.dialog.selectGoods.hint', '请输入关键字查找')" v-model="searchParam.keyString"></el-input>
            <el-button type="primary" plain @click="queryList()">{{$STR('COMMON.common.btn.search', '搜索')}}</el-button>
            <el-button plain @click="theOriginal.pop()" v-show="theOriginal.length>1&&searchParam.orgType!=='0'">{{$STR('goods.goodDetails.back', '返回')}}</el-button>
        </div>
        <p class="split">
            <el-checkbox v-model="checkAll" :indeterminate="indeterminate">{{$STR('COMMON.common.checkbox.all', '全选')}}</el-checkbox>
            <!-- <el-checkbox v-model="isOrgTeam" v-if="hasPermission(isOrgTeamPermission[whichOne])">{{$STR('WAREHOUSE.statistics.search.by.team', '经销商团队收货数据')}}</el-checkbox> -->
            <el-checkbox v-model="isOrgTeam" v-if="hasPermission(isOrgTeamPermission[whichOne])">{{whichOne === 'in' ? '经销商团队收货数据' : '经销商团队被收货数据'}}</el-checkbox>
        </p>
        <el-checkbox-group v-model="currentCheckList" class="org-check-group">
            <p v-for="(org, index) of list" :key="index">
                <el-checkbox :label="org" @change="checked => changeOrg(checked, org)" :checked="checkedList.findIndex(item => item.orgId === org.orgId) !== -1">{{org.orgName + ((isOrgTeam && parseInt(searchParam.orgType) === 3) ? '(团队)' : '')}}</el-checkbox>
                <el-button type="text" v-show="searchParam.orgType!=='0' && isShowNext" @click="theOriginal.push(org.orgId)">{{$STR('COMMON.common.btn.lower', '查看下一级')}}</el-button>
            </p>
        </el-checkbox-group>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchParam.current"
                       :page-sizes="[50, 100, 200, 500, 1000]" :page-size="searchParam.rows" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <div slot="footer" class="dialog-footer">
            <el-button plain @click="closeDialog">{{$STR('COMMON.common.btn.cancel', '取消')}}</el-button>
            <el-button type="primary" plain @click="confirm">{{$STR('COMMON.common.btn.confirm', '确定')}}</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: ['visible', 'chosenOrgTeamList', 'whichOne'],
    computed: {
        dialogVisible: {
            get: function () { return this.visible; },
            set: function () { return; }
        },
        checkAll: {
            get: function () { return this.currentCheckList.length === this.list.length; },
            set: function (val) {
                if (!val) this.checkedList = this.checkedList.filter(oldItem => { return this.list.findIndex(newItem => newItem.orgId === oldItem.orgId ) === -1; });
                return val ? this.currentCheckList = this.list : this.currentCheckList = [];
            }
        },
        indeterminate () {
            let self = this;
            if (this.checkedList && this.checkedList.length > 0) {
                self.isShowNext = false;
            } else {
                self.isShowNext = true;
            }
            return this.currentCheckList.length !== this.list.length && this.currentCheckList.length !== 0;
        }
    },
    watch: {
        theOriginal (val) {
            this.searchParam.parentId = val[val.length - 1];
            this.queryList();
        },
        currentCheckList (val) {
            if (!(val instanceof Array)) return this.currentCheckList = this.list.filter(item => { return this.checkedList.findIndex(check => item.orgId === check.orgId) > -1; } );
            val.forEach(check => {
                let result = this.checkedList.findIndex(item => item.orgId === check.orgId );
                if (result === -1) this.checkedList.push(check);
            });
        },
        dialogVisible (val) {
            if (!val) return;
            if (this.chosenOrgTeamList) {
                if (this.chosenOrgTeamList.orgIdList) {
                    let tempCheckList = [];
                    this.chosenOrgTeamList.orgIdList.forEach(id => {
                        this.list.forEach(row => {
                            if (row.orgId === id) {
                                tempCheckList.push(row);
                            }
                        });
                    });
                    this.checkedList = JSON.parse(JSON.stringify(tempCheckList));
                }
            }
            this.currentCheckList = this.list.filter(item => { return this.checkedList.findIndex(check => item.orgId === check.orgId) > -1; } );
        },
        list (val) {
            this.currentCheckList = val.filter(item => { return this.checkedList.findIndex(check => item.orgId === check.orgId) > -1; } );
        },
        'searchParam.orgType' (val) {
            this.searchParam.keyString = '';
            this.theOriginal.splice(1, this.theOriginal.length - 1);
        }
    },
    data () {
        return {
            userInfo: baseStore.getUserInfo(), // 用户信息
            theOriginal: [], // 组织机构树
            searchParam: {
                parentId: '',
                orgType: '3',
                keyString: '',
                rows: 50,
                current: 1
            },
            total: 0,
            list: [],
            statusMap: [
                {id: '3', name: this.$STR('ORDER.applyInfo.data.statusList.3', '经销商')}
            ],
            isOrgTeam: false, // 是否按照经销商团队查询
            currentCheckList: [], // 当前页所选
            checkedList: [],
            isShowNext: true, //是否显示下级按钮
            isOrgTeamPermission: {
                'in': 'menu:order:in:statistics:jindafu',
                'out': 'menu:order:out:statistics:jindafu'
            }
        };
    },
    created () {
        this.theOriginal.push(this.userInfo.orgId);
        this.searchParam.parentId = this.userInfo.orgId;
    },
    methods: {
        // 选中/取消组织
        changeOrg (checked, org) {
            if (!checked) this.checkedList = this.checkedList.filter(item => { return item.orgId !== org.orgId; });
        },
        // 关闭弹窗
        closeDialog () {
            this.$parent.teamDialogVisible = false;
        },
        // 确定选择
        confirm () {
            this.$parent.teamDialogVisible = false;
            let teamList = this.isOrgTeam ? this.checkedList.filter(org => { return org.orgId !== this.userInfo.orgId; } ) : this.checkedList;
            let orgTeamForm = {
                id: '',
                teamName: '',
                teamList: teamList,
                orgIdList: []
            };
            if (teamList) {
                teamList.forEach((data, index) => {
                    orgTeamForm.orgIdList.push(data.orgId);
                    if (index === 0) {
                        orgTeamForm.id = data.orgId;
                        orgTeamForm.teamName = data.orgName;
                    }
                });
            }
            this.$emit('submitOrgTeam', orgTeamForm);
        },
        // 查询组织机构选择列表
        queryList (current = 1) {
            this.searchParam.current = current;
            this.searchParam.parentId = this.searchParam.orgType === '0' ? '' : this.theOriginal[this.theOriginal.length - 1];
            this.$http.get(WebApi.warehouse.getOrgList, {
                params: this.searchParam
            }).then(res => {
                this.list = res.data.rows;
                this.total = res.data.total;
                this.checkedList.length = 0;
            });
        },
        handleSizeChange(val) {
            this.searchParam.rows = val;
            this.queryList();
        },
        handleCurrentChange(val) {
            this.queryList(val);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/cloud/warehouse/orgTeamSelect.vue